import {API} from "aws-amplify";
import {
    ATTR_MAIN_PROJ_ID,
    ATTR_OBJ_ID, ATTR_OBJ_STATE,
    ATTR_SORT_ORDER_I, ATTR_UPDATED_MS_I, currentTimeMs, getActiveProject, getCustomerMainPrjHelp,
    getDevId,
    getUserEmail, OBJ_STATE_TO_DEL, prosLog,
    prosLogClearDt, prosLogDt, prosLogErr,
    ProsProject,
    reserveAwsApi, STR_NO_VALUE, STR_YES,
} from "./ProsConnect";
import {PRODECT_SW_VERSION} from "../config";

const CH_TAG_INTRO = 'tag_ch1'
export const TAG_KEEP_OPEN = 'tag_ch2'
const CH_TAG_GENERAL_HINTS = 'tag_ch3'

const TAG_STATE = 'tag2'
const TAG_VIEW = 'tag3'
const TAG_POPUP = 'tag4'
const TAG_FIELD_TAG = 'txt1'
const STATE_APPROVED = '2'

let helpContextView = -1
let helpContextPopup = -1

let helpProject
let helpDeskHandler
function refreshHelp() {
    if (helpDeskHandler && helpProject && helpProject.objs.length > 0) {
        let showingHelpContext = helpContextView.toString() + helpContextPopup.toString()
        helpDeskHandler(showingHelpContext)
    }
}

export async function awaitLoadHelpProject() {
    helpProject = new ProsProject({}, refreshHelp, true)
    try {
        prosLogClearDt()
        await reserveAwsApi(true, 'GET help')
        let projectData = await API.get("prodect",
            '/websynch?email=' + getUserEmail()
            + '&id=' + getDevId()
            + '&project=HELP');
        const startedToFetch = currentTimeMs()
        await reserveAwsApi(false, 'GET help')
        if (Array.isArray(projectData.objs)) {
            projectData.objs.sort(function(a, b){return a[ATTR_SORT_ORDER_I]-b[ATTR_SORT_ORDER_I]});
            helpProject.projectObjectsLoaded(projectData, true, currentTimeMs() - startedToFetch)
            prosLogDt("HELP loaded")
        } else {
            prosLogErr("Failed to load help-1")
            helpProject = undefined
        }
    } catch (e) {
        prosLogErr(e);
        prosLogErr("Failed to load help-2")
        helpProject = undefined
        await reserveAwsApi(false, 'GET help failed')
    }
}

let customerHelpMainPrjId
let customerHelp

export function projectViewChanged(main_proj_id = undefined) {
    let new_id = undefined
    if (main_proj_id && main_proj_id !== customerHelpMainPrjId) {
        new_id = main_proj_id
    }
    if ( ! new_id && getActiveProject() &&
        getActiveProject().getAttr(ATTR_MAIN_PROJ_ID) !== STR_NO_VALUE &&
        getActiveProject().getAttr(ATTR_MAIN_PROJ_ID) !== customerHelpMainPrjId) {
            new_id = getActiveProject().getAttr(ATTR_MAIN_PROJ_ID)
    }
    if (new_id) {
        customerHelpMainPrjId = new_id
        customerHelp = undefined
        ifHelpDeskLoadCustomerHelp()
    }
}

async function ifHelpDeskLoadCustomerHelp() {
    if (isShowingHelpDesk()) {
        await awaitLoadCustomerHelp(customerHelpMainPrjId)
    }
}

export async function awaitLoadCustomerHelp(main_prj_id, force_fetch = false) {
    if ( ! customerHelpMainPrjId) {
        return
    }
    if (customerHelp && ! force_fetch) {
        return
    }
    customerHelp = await getCustomerMainPrjHelp(main_prj_id)
    if ( ! customerHelp) {
        customerHelp = {}
        return
    }
    let updated = ''
    if (customerHelp.length > 0) {
        updated = customerHelp[0][ATTR_UPDATED_MS_I]
    }
    if (helpDeskHandler) {
        helpDeskHandler('customerHelp' + updated)
    }
}

export function isCustomerHelpAvailable() {
    ifHelpDeskLoadCustomerHelp()
    return !(!customerHelp || (typeof customerHelp === 'object' && Object.keys(customerHelp).length === 0))
}

export function awaitUnloadCustomerHelp() {
    customerHelp = undefined
}

// When active project is same as help update help content when get newer items from server
export function refreshHelpProject(activePid, serverUpdates) {
    if (helpProject && helpProject.getPid() === activePid) {
        helpProject.handleRefresh(serverUpdates)
    }
}

// When active project is same as help this get called when removing item from an active project
export function removeFromHelp(deleteItemId) {
    if (helpProject) {
        for (let obj of helpProject.objs) {
            if (obj[ATTR_OBJ_ID] === deleteItemId) {
                obj[ATTR_OBJ_STATE] = OBJ_STATE_TO_DEL
            }
        }
        refreshHelp()
    }
}

/**
 * Get help context which state is approved to be deployed and match context sensitive, general or all
 * @param filterTxt
 * @param tipScope      "currentViewTips" | "productIntro" | "customerHelp"
 * @returns {[]|*[]}    3-dim arrays [reports][obs][items]
 *
 * When using text search - filter text longer than 2 - return all approved with matching text
 * Else if "currentViewTips" tagged as display scope specific
 * or "productIntro" help that is tagged as product intro
 *
 * Help that is tagged by CH_TAG_GENERAL_HINTS is returned independent from scope
 *
 */
export function getHelpContent(filterTxt, tipScope) {
    if (tipScope === 'customerHelp') {
        return customerHelp ? customerHelp : []
    }
    if (helpProject) {
        helpProject.selectProjectAllReports()
    }
    let helpItems = helpProject ? helpProject.getUiList(undefined, filterTxt, false) : []
    return helpItems.filter(report => {
        let checkIntro
        let checkTag, tagValue
        if (tipScope === "currentViewTips") {
            checkTag = helpContextPopup >= 0 ? TAG_POPUP: TAG_VIEW
            tagValue = helpContextPopup >= 0 ? helpContextPopup: helpContextView
        } else if (tipScope === "productIntro") {
            checkIntro = true
        }
        report.obsList = report.obsList.filter(obs => {
            let matchIntroduction = checkIntro ? obs[CH_TAG_INTRO] === STR_YES: true
            let matchTag = checkTag ? obs[checkTag] === tagValue : true
            let matchCommon = obs[CH_TAG_GENERAL_HINTS] === STR_YES
            return obs[TAG_STATE] === STATE_APPROVED &&
                (filterTxt.length > 2 || (matchIntroduction && matchTag) || matchCommon)
        })
        return report.obsList.length > 0
    })
}

export async function getPopupHelpContent(key) {
    if (!helpProject) {
        await awaitLoadHelpProject()
    }
    helpProject.selectProjectAllReports()
    let helpItems = helpProject.getUiList(undefined, "", false)
    let foundObs
    helpItems.find(report => {
        foundObs = report.obsList.find(obs =>
            obs[TAG_STATE] === STATE_APPROVED &&
            HELP_POPUP_MAP_TAG3[key] === obs[TAG_POPUP])
        return foundObs
    })
    return foundObs
}

// Show specific view info - used at least to show what's new in latest SW version
export function getHelpContentByName(viewName) {
    if (!helpProject) {
        return null
    }
    helpProject.selectProjectAllReports()
    let helpItems = helpProject.getUiList(undefined, "", false)
    return helpItems.filter(report => {
        report.obsList = report.obsList.filter(obs =>
            obs[TAG_STATE] === STATE_APPROVED &&
            obs[TAG_VIEW] === HELP_VIEW_MAP_TAG2[viewName])
        return report.obsList.length > 0
    })
}

// Show specific small help info - used for specific fields showing a small nugget of help not full help page
export async function getHelpContentByField(txtField) {
    if(!txtField) return null
    if (!helpProject) {
        await awaitLoadHelpProject()
    }
    helpProject.selectProjectAllReports()
    let helpItems = helpProject.getUiList(undefined, "", false)
    let foundObs
    helpItems.find(report => {
        foundObs = report.obsList.find(obs =>
            obs[TAG_STATE] === STATE_APPROVED &&
            obs[TAG_FIELD_TAG] === txtField)
        return !!foundObs
    })
    return foundObs
}

export function subscribeToHelpRefreshed(handleHelpUpdated, host) {
    // console.log('HELP subscribed by', host)
    helpDeskHandler = handleHelpUpdated
    if (!helpProject) {
        awaitLoadHelpProject()
    } else {
        refreshHelp()
    }
}

export function unSubscribeToHelpRefreshed(host) {
    // console.log('HELP UN-subscribed by', host)
    helpDeskHandler = undefined
}

const HELP_VIEW_MAP_TAG2 = {
    'main': '0',
    'list': '1',        // VIEW_MODE_LIST
    'table': '2',       // VIEW_MODE_TABLE
    'matrix': '3',      // VIEW_MODE_CALENDAR
    'search': '4',
    'projectSettings': '5',
    'locPict': '6',
    'admin': '7',
    'newProject': '8',
    'sentReports': '9',
    'settings': '10',
    'excel': '11',
    'bookmarks': '12',
    'versionInfo': '13',
    'mainProj-customer': '14',
    'mainProj-priceCalc': '15',
    'mainProj-billing': '16',
    'mainProj-project': '17',
    'mainProj-confirm': '18',
    'moveProject': '19',
    'customerUsageInfo': '20',
    'dashboard': '21',          // VIEW_MODE_DASHBOARD
    'notificationRules': '22',
    'notificationRuleEdit': '23',
    'kanban': '24',             // VIEW_MODE_CALENDAR
    'comm-settings': '25',
    'customer-enum-list': '26',
    'customer-pdf-page': '27',
    'dashboard-main': '28',          // Main project dashboard
    'mainProj-help': '29',          // Main project specific help
}

const HELP_POPUP_MAP_TAG3 = {
    'obsMenu': '0',
    'reportMenu': '1',
    'commentMenu': '2',
    'obsSettings': '3',
    'pictureMenu': '4',
    'importPicture': '5',
    'spare': '6',//Sampo: i think this is not used anywhere
    'reportSettings': '7',
    'tableColumnEditor': '8',
    'share': '9',
    'timeMatrixTags': '10',
    'enumListSettings': '11',
    'enumListSelecting': '12',
}

//home.js Help button indicator if help is available for this view
// export function hasViewHelp() {
//     return helpProject && helpProject.isProjectLoaded() && getHelpContentByName('currentViewTips')
//         && getHelpContentByName('currentViewTips').length > 0
// }

export function getPopupHelp(context) {
    return HELP_POPUP_MAP_TAG3[context]
}

export function hasHelp() {
    return helpProject && helpProject.isProjectLoaded()
}

let showingHelpDesk

if (localStorage.getItem("showingHelpDesk")) {
    showingHelpDesk = localStorage.getItem("showingHelpDesk") === "true" || !hasShowVersionInfo()
} else {
    showingHelpDesk = true
}

// Hint - to test showing version info use browser inspect / application / delete key "prodectVersion" & refresh browser
export function hasShowVersionInfo() {
    return localStorage.getItem("prodectVersion") === PRODECT_SW_VERSION
}

export function setVersionInfoShown() {
    if (!hasShowVersionInfo()) {
        localStorage.setItem("prodectVersion", PRODECT_SW_VERSION)
    }
}

export function setShowingHelpDesk(shouldShow) {
    showingHelpDesk = shouldShow
    if (shouldShow) {
        localStorage.setItem("showingHelpDesk", "true")
    } else {
        localStorage.setItem("prodectVersion", PRODECT_SW_VERSION)
        setVersionInfoShown()
    }
    ifHelpDeskLoadCustomerHelp()
}

export function isShowingHelpDesk() {
    return showingHelpDesk
}

export function setHelpContext(viewName) {
    if (viewName === 'closePopup') {
        helpContextPopup = -1
        refreshHelp()
        return
    }
    for (let tag of Object.keys(HELP_VIEW_MAP_TAG2)) {
        if (tag === viewName) {
            helpContextView = HELP_VIEW_MAP_TAG2[tag]
            prosLog('HELP view', viewName, helpContextView)
            helpContextPopup = -1
            refreshHelp()
            return
        }
    }
    for (let tag of Object.keys(HELP_POPUP_MAP_TAG3)) {
        if (tag === viewName) {
            helpContextPopup = HELP_POPUP_MAP_TAG3[tag]
            prosLog('HELP popup', viewName, helpContextPopup)
            refreshHelp()
            return
        }
    }
    helpContextView = -1
    helpContextPopup = -1
    prosLogErr('Unknown help context', viewName)
}
